import { StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ApiError } from '@app/shared/models/api/api-error.model';
import { AkitaFeaturedState, createInitialFeaturedState } from '../models/featured.state';
import { FeaturedReviewModel } from '@app/shared/models/api/featured-review.model';
import {
  FeaturedReviewStatsModel,
  getStatsFromReviewsArray,
} from '@app/shared/models/api/featured-review-stats.model';
/* import { FeaturedReviewStatsModel } from /*   getStatsFromReviewsArray,
 '@app/shared/models/api/featured-review-stats.model'; */

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'featured', resettable: true })
export class AkitaFeaturedStore extends Store<AkitaFeaturedState> {
  constructor() {
    super(createInitialFeaturedState());
  }

  public setFeaturedReviews(
    language?: string | null,
    phoneModel?: string | null,
    products?: Array<FeaturedReviewModel> | null
  ): void {
    if (language && phoneModel) {
      this.update((state: AkitaFeaturedState) => {
        const featuredReviews = { ...(state.featuredReviews || {}) };
        const featuredReviewsStats = { ...(state.featuredReviewsStats || {}) };
        featuredReviews[language] = featuredReviews[language] || {};
        featuredReviewsStats[language] = featuredReviewsStats[language] || {};
        featuredReviewsStats[language][phoneModel] =
          featuredReviewsStats[language][phoneModel] || new FeaturedReviewStatsModel();

        featuredReviews[language][phoneModel] = products || new Array(0);
        featuredReviewsStats[language][phoneModel] = getStatsFromReviewsArray(products);
        return {
          featuredReviews: featuredReviews,
          featuredReviewsStats: featuredReviewsStats,
        };
      });
    }
  }

  public setAllFeaturedReviews(
    language?: string | null,
    products?: Array<FeaturedReviewModel> | null
  ): void {
    if (language) {
      this.update((state: AkitaFeaturedState) => {
        const featuredReviews = { ...(state.featuredReviews || {}) };
        const featuredReviewsStats = { ...(state.featuredReviewsStats || {}) };
        featuredReviews[language] = featuredReviews[language] || {};
        featuredReviewsStats[language] = featuredReviewsStats[language] || {};

        (products || new Array(0)).map((product) => {
          if (!featuredReviews[language][product.model]) {
            featuredReviews[language][product.model] = new Array(0);
          }
          featuredReviews[language][product.model].push(product);

          featuredReviewsStats[language][product.model] =
            getStatsFromReviewsArray(
              products?.filter((x) => x.model === product.model)
            ) || new FeaturedReviewStatsModel();
        });

        return {
          featuredReviews: featuredReviews,
          featuredReviewsStats: featuredReviewsStats,
        };
      });
    }
  }

  public toggleFetchingFeaturedReviews(
    language?: string | null,
    fetching?: boolean | null
  ): void {
    if (language) {
      this.update((state: AkitaFeaturedState) => {
        const fetchingFeaturedReviews = {
          ...(state.fetchingFeaturedReviews || {}),
        };
        fetchingFeaturedReviews[language] = Boolean(fetching);
        return {
          fetchingFeaturedReviews: fetchingFeaturedReviews,
        };
      });
    }
  }

  public setErrorFetchingFeaturedReviews(
    language?: string | null,
    error?: ApiError | null
  ): void {
    if (language) {
      this.update((state: AkitaFeaturedState) => {
        const errorFetchingFeaturedReviews = {
          ...(state.errorFetchingFeaturedReviews || {}),
        };
        errorFetchingFeaturedReviews[language] = error || null;
        return {
          errorFetchingFeaturedReviews: errorFetchingFeaturedReviews,
        };
      });
    }
  }
}
